<template>
  <div class="portada-xv" ref="rootRef" aria-label="XV Cover">
    <!-- FLORES DECORATIVAS -->
    <img src="@/assets/floor.png" class="flor flor-1" alt="" />
    <img src="@/assets/regal.png" class="flor flor-2" alt="" />
    <img src="@/assets/floor.png" class="flor flor-3" alt="" />

    <!-- BOLA DISCO GIRANDO -->
    <img src="@/assets/diisco.png" class="bola bola-izquierda" alt="" />

    <!-- IMAGEN CON RECORTE -->
    <div class="imagen-xv-wrapper">
      <img src="@/assets/8E797218-12F3-4AA5-8B6B-607B07D44B75.webp" class="imagen-xv" alt="Main photo" />
    </div>

    <!-- LOGO -->

    <!-- TEXTO -->
    <section class="texto-xv">
      <p class="frase-bendicion">
        With the blessing of God <br />
        and my Parents:
      </p>

      <div class="separador-elegante"></div>

      <h1 class="nombre-protagonista">Lina &nbsp;y&nbsp; Josue</h1>
<br />
      <!-- NUEVO TEXTO PADRINOS 
      <p class="texto-padrinos"><br />
      Godparents of Honor:<br />
      </p>

      <h2 class="nombre-padrino"> Lina y Josue</h2>-->

      <p class="parrafo-presentacion">
        There are moments that define our lives, remaining engraved in the soul and memory.
        Today I experience one of those special moments and I want to share it with those
        who hold a place in my heart.
      </p>
    </section>
  </div>
</template>
<script>
import { onMounted, ref, nextTick } from 'vue'
import gsap from 'gsap'

export default {
  name: 'PortadaArley',
  setup() {
    const rootRef = ref(null)

    onMounted(async () => {
      await nextTick()

      const $ = (sel) => Array.from(gsap.utils.toArray(sel)).filter(Boolean)

      const foto = $('.imagen-xv-wrapper')
      const flores = ['.flor-1', '.flor-2', '.flor-3'].flatMap($)
      const texto = [
        '.frase-bendicion',
        '.separador-elegante',
        '.nombre-protagonista',
        '.texto-padrinos',
        '.nombre-padrino',
        '.parrafo-presentacion'
      ].flatMap($)

      gsap.set([...foto, ...flores, ...texto], { autoAlpha: 0, y: 28 })
      gsap.set(flores[0], { rotate: -8, scale: 0.95 })
      gsap.set(flores[1], { rotate: -18, scale: 0.94 })
      gsap.set(flores[2], { rotate: -12, scale: 0.94 })

      const io = new IntersectionObserver((entries) => {
        entries.forEach((e) => {
          if (!e.isIntersecting) return

          const tl = gsap.timeline({ defaults: { ease: 'power2.out' } })

          tl.fromTo(
            foto,
            { scale: 0.94, y: 40, filter: 'blur(6px)' },
            { autoAlpha: 1, scale: 1, y: 0, filter: 'blur(0px)', duration: 1.15 }
          )

          tl.to(
            flores,
            {
              autoAlpha: 1,
              y: 0,
              rotate: (i) => [-2, -6, -4][i] || -4,
              duration: 0.9,
              stagger: 0.12
            },
            '-=0.55'
          )

          tl.to(texto, { autoAlpha: 1, y: 0, duration: 0.8, stagger: 0.15 }, '-=0.25')

          gsap.to(flores[0], { y: '-=10', duration: 2.2, yoyo: true, repeat: -1, ease: 'sine.inOut' })
          gsap.to(flores[1], { y: '+=12', x: '-=4', duration: 2.6, yoyo: true, repeat: -1, ease: 'sine.inOut', delay: 0.2 })
          gsap.to(flores[2], { y: '-=8', duration: 2.0, yoyo: true, repeat: -1, ease: 'sine.inOut', delay: 0.1 })
          gsap.to(foto, { scale: 1.01, duration: 3.2, yoyo: true, repeat: -1, ease: 'sine.inOut' })

          io.disconnect()
        })
      }, { threshold: 0.45 })

      if (rootRef.value) io.observe(rootRef.value)
    })

    return { rootRef }
  }
}
</script>



<style scoped>

  /* TODO TU ESTILO ORIGINAL SE RESPETA */

.texto-padrinos{
  font-family: "Playfair Display", serif;
  font-size: clamp(16px, 2.4vw, 20px);
  color:#4a4a4a;
  margin: 6px 0 10px;
}

.nombre-padrino{
  font-family: "titulos", cursive;
  font-size: 46px;
  color:#8fbbdf;
  margin: 0;
  line-height:1.2;
}
.portada-xv{
  position:relative;
  width:100%;
  min-height:100vh;
  overflow:visible;
  display:flex;
  flex-direction:column;
  align-items:center;
  justify-content:flex-start;
  padding:48px 16px 56px;
}

/* 🔥 FONDO FIXED REAL (funciona en celular) */
.portada-xv::before{
  content:"";
  position:fixed;
  inset:0;
  z-index:-1;

  background-image: 
    linear-gradient(rgba(255, 255, 255, 0.73), rgba(255, 255, 255, 0.85)),
    url('@/assets/ff.jpg');

  background-size:cover;
  background-position:center;
  background-repeat:no-repeat;

  will-change: transform;
}
/* Marco con recorte superior redondeado (look luxury) */
.imagen-xv-wrapper{
  width: min(92vw, 360px);
  height: calc(min(92vw, 360px) * 1.5);
  margin-top: 6px;
  border-radius: 180px 180px 0 0;
  overflow: hidden;
  z-index: 2;
  background:#fff;
  box-shadow:
    0 12px 40px rgba(0,0,0,.18),
    0 2px 8px rgba(0,0,0,.06);
  will-change: transform, filter, opacity;
}
.imagen-xv{
  width:100%;
  height:100%;
  object-fit:cover;
  display:block;
}

/* LOGO CENTRADO */
.logo-portada{
  margin-top: 18px;
  max-width: 140px;
  width: 40vw;
  height: auto;
  display: block;
  margin-left: auto;
  margin-right: auto;
}

/* Texto */
.texto-xv{
  max-width: 620px;
  text-align:center;
  margin-top: 22px;
  padding: 0 8px;
}
.frase-bendicion{
  font-family: "Playfair Display", serif;
  font-size: clamp(18px, 2.6vw, 24px);
  color:#2f2e2e;
  line-height:1.5;
  margin: 20px 0 10px;
}
.separador-elegante{
  width:110px;
  height:2px;
  margin:12px auto 16px;
  background: linear-gradient(90deg, transparent, #d9b7c6, transparent);
  border-radius: 2px;
}
.nombre-protagonista{
  font-family: "titulos", cursive;
  font-size: 57px;
  color:#8fbbdf;
  margin: 0 0 8px 0;
  line-height:1.1;
}
.parrafo-presentacion{
  font-family: "quote", sans-serif;
  font-size: clamp(14px, 2.6vw, 16px);
  color:#3d3c3c;
  line-height:1.7;
  margin-top: 6px;
}

/* FLORES */
.flor{
  position:absolute;
  width:min(44vw, 240px);
  z-index:10;
  transform-origin:center;
  will-change: transform, opacity;
}
.flor-1{ top:-10px; left:-70px; z-index:5; }
.flor-2{ top:-40px; right:-35px; transform: rotate(-340deg) !important; z-index:1; width:min(60vw, 290px) !important; }
.flor-3{ bottom:-50px; left:-90px; transform: rotate(-30deg); z-index:9;}

/* BOLA DISCO */
.bola{
  position:absolute;
  width:140px;
  animation: girar 10s linear infinite;
  opacity:.85;
  z-index:1;
  will-change: transform;
}
.bola-izquierda{ left:310px; bottom:-100px; z-index:9;}
@keyframes girar {
  0% {
    transform: scale(1);
    opacity: 0.9;
  }
  50% {
    transform: scale(1.1);
    opacity: 1;
  }
  100% {
    transform: scale(1);
    opacity: 0.9;
  }
}


/* Responsive refinado */
@media (min-width: 992px){
  .portada-xv{ padding-top:64px; }
  .imagen-xv-wrapper{ margin-top: 0; }
}
</style>
